import { useAppDispatch, useAppSelector } from "app/hooks";
import { setAutoRotate } from "features/krpano/details-slice";
import { useEffect } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type UseAutoRotate = (krpanoFeaturesReady: boolean) => void;

/**
 * # Autorotate control for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useAutoRotate: UseAutoRotate = (krpanoFeaturesReady) => {
  const autoRotate = useAppSelector((state) => state.krpano.autoRotate);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (krpanoFeaturesReady) {
      window.krpano.call(`updateAutoRotate(${autoRotate});`);
    }
  }, [krpanoFeaturesReady, autoRotate]);

  // This listener is for when krpano is used to change autorotate-mode
  useEffect(() => {
    const setAutoRotateModeHandler = (
      event: WindowEventMap["krpano__autorotate_mode"]
    ) => {
      if (
        notNullNorUndefined(event.detail) &&
        event.detail.autoRotate !== undefined
      ) {
        dispatch(setAutoRotate(event.detail.autoRotate));
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener(
      "krpano__autorotate_mode",
      setAutoRotateModeHandler
    );
    return () => {
      window.removeEventListener(
        "krpano__autorotate_mode",
        setAutoRotateModeHandler
      );
    };
  }, [dispatch]);
};
